import { Component, inject, ViewChild, NgZone } from '@angular/core';
import { CellTemplateDirective, ColumnComponent, GridComponent } from '@progress/kendo-angular-grid';
import { DEFAULT_LANGUAGE } from 'src/app/app.constants';
import { LanguageService } from 'src/app/services/language.service';
import { FormService } from 'src/app/services/form.service';
import { TranslatePipe } from '@ngx-translate/core';
import { Product } from 'src/app/models/product.model';
import { take } from 'rxjs';

@Component({
    selector: 'app-order-resume',
    imports: [
        GridComponent,
        ColumnComponent,
        CellTemplateDirective,
        TranslatePipe
    ],
    templateUrl: './order-resume.component.html',
    styleUrl: './order-resume.component.scss'
})
export class OrderResumeComponent {
  @ViewChild('grid', { static: true }) grid: GridComponent;

  private languageService = inject(LanguageService);
  private formService = inject(FormService);

  lang = this.languageService.currentLanguage;
  form = this.formService.form;

  get gridData(): any[] {
    const gridItems: any[] = [];
    const bikes = this.form().bikes || [];
    const accessories = this.form().accessories || [];

    if (accessories.length > 0) {
      accessories.forEach(a => {
        gridItems.push({
          ...a,
          type: 'accessory',
          name: this.translateName(a),
        });
      });
    }

    if (bikes.length > 0) {
      bikes.forEach(b => {
        gridItems.push({
          ...b,
          type: 'bike',
          quantity: 1,
          price: (b.price / b.quantity),
          height: b.height && b.height > 0 ? b.height : undefined,
          name: this.translateName(b),
        });
        if (b.accessories && b.accessories.length > 0) {
          b.accessories.forEach(a => {
            gridItems.push({
              ...a,
              type: 'bike-accessory',
              name: this.translateName(a),
            });
          });
        }
      });
    }

    return gridItems;
  }

  private translateName(item: Product) {
    return item.translations[this.lang()] || item.translations[DEFAULT_LANGUAGE];
  }

}
